var map = {
	"./settings.development": 9299,
	"./settings.development.js": 9299,
	"./settings.js": 7272,
	"./settings.local-development": 7873,
	"./settings.local-development.js": 7873,
	"./settings.production": 5079,
	"./settings.production.js": 5079,
	"./settings.staging": 9603,
	"./settings.staging.js": 9603
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7520;